import {IPropertyTypeStrategyInterfaces} from '../../../../types/IPropertyTypeStrategyInterfaces'

export enum NumberRoundTypes {
  Up = 'up',
  Down = 'down',
  Auto = 'auto',
}

export interface INumberPropertyTypeInterfaces extends IPropertyTypeStrategyInterfaces {
  inputValue: number
  storedValue: number
  fullValue: number
  cacheValue: number
  template: {
    preOptionsData: null
    value: number,
  }
  options: {
    prefix: string
    suffix: string
    roundDigits: number|null
    roundType: NumberRoundTypes|null
    inputStep: number
  }
  // inputValue: number
  // storedValue: number
  // fullValue: number|null
  // cacheValue: number
}
